module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// E:/R1/Angular/turnero/web-visor-cliente/~/core-js/modules/_iter-step.js
// module id = ../../../../core-js/modules/_iter-step.js
// module chunks = 0